import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage, 
    DefaultSettingsActionTypes,
    GET_MASTERDATABYNAME,
    SAVE_DEFAULT_TARGET_SETTINGS,
    GET_DEFAULT_TARGET_SETTINGS,
    DownLoadClientListActionTypes,
    DOWNLOAD_CLIENT_LIST, 
    GET_DOMAINS_BASED_ON_CLIENT,
    GET_PROGRAM_BASED_ON_CLIENT,
    GET_CLIENT_BEHAVIOUR_LIST_DOWNLOAD,
    GET_PATIENTS_LIST_FOR_FILTER,
    DOWNLOAD_BEHAVIOR_RAW_DATA_TEMPLATE
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';

import { checkHttpStatusAuthCheck,createSearchUrlForCustomAPI  } from '../../../../../../actions/utilAction';



export const getPatientsList = (pageSize=0,ViewTeamClientsOnly=false) => { 
  return (dispatch,getState) =>{
    dispatch(actionCreator(DownLoadClientListActionTypes.get_PatientsList.REQUEST));
    fetch(`${GET_PATIENTS_LIST_FOR_FILTER}?pageSize=${0}&ViewTeamClientsOnly=${ViewTeamClientsOnly}`,{
      method: 'GET',
       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
    .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
    .then(function (response) {
        dispatch(actionCreator(DownLoadClientListActionTypes.get_PatientsList.SUCCESS, response.data));
    })
    .catch(function (error) {
        dispatch(actionCreator(DownLoadClientListActionTypes.get_PatientsList.FAILURE, error));
        console.log('error getMasterData ..', error);
    });
  }
}


export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(DownLoadClientListActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {
                dispatch(actionCreator(DownLoadClientListActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    };
};

export const downloadClientList = (params) => {
  return (dispatch, getState) => {
    let query_params =`?PatientIds=${params.PatientIds}&ProgramIds=${params.ProgramIds}&DomainIds=${params.DomainIds}&extension=${params.extension}`;
    dispatch(actionCreator(DownLoadClientListActionTypes.downloadClientList.REQUEST));
    fetch(`${DOWNLOAD_CLIENT_LIST}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName =`CLIENT LIST FOR TARGETS.${params.extension?params.extension:'csv'}`;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(DownLoadClientListActionTypes.downloadClientList.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const getDomainBasedOnClient = (patientIds) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(DownLoadClientListActionTypes.get_DomainsList.REQUEST));
        fetch(`${GET_DOMAINS_BASED_ON_CLIENT}?ClientIds=${patientIds}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DownLoadClientListActionTypes.get_DomainsList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DownLoadClientListActionTypes.get_DomainsList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_DC_PatientSkillAcqGraphAPI', error);                
            });
    };
};



export const get_clientBehaviourListDownload = (params) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(DownLoadClientListActionTypes.get_clientBehaviourListDownload.REQUEST));
        fetch(`${GET_CLIENT_BEHAVIOUR_LIST_DOWNLOAD}?PatientIds=${params.patientIds}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName ="CLIENT LIST FOR BEHAVIORS.xlsx";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(DownLoadClientListActionTypes.get_clientBehaviourListDownload.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
    };
};

export const getProgramList = (patientIds,DomainIds) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(DownLoadClientListActionTypes.get_ProgramList.REQUEST));
      fetch(`${GET_PROGRAM_BASED_ON_CLIENT}?ClientIds=${patientIds}&DomainIds=${DomainIds}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(DownLoadClientListActionTypes.get_ProgramList.SUCCESS, response));
              } else {
                  dispatch(actionCreator(DownLoadClientListActionTypes.get_ProgramList.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_DC_PatientSkillAcqGraphAPI', error);                
          });
  };
};

export const downloadBehaviorRawDataTemplate = (params) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(DownLoadClientListActionTypes.downloadBehaviorRawDataTemplate.REQUEST));
        fetch(`${DOWNLOAD_BEHAVIOR_RAW_DATA_TEMPLATE}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(params),
        })
            .then(function checkHttpStatus(response) {
                if (response.status >= 200 && response.status < 204) {
                    return response;
                } else if (response.status === 204) {
                    return true;
                } else if (response.status >= 400 && response.status < 500) {
                    return response;
                } else {
                    var error = new Error(response.statusText);
                    error.response = response;
                    throw error;
                }
            })
            .then(function(response) {
                return response.blob();
            })
            .then(function(response) {
                const url = window.URL.createObjectURL(response);
                const link = document.createElement("a");
                link.href = url;
                const fileName = "BehaviorRawDataTemplate.xlsx";
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                dispatch(actionCreator(DownLoadClientListActionTypes.downloadBehaviorRawDataTemplate.SUCCESS));
            })
            .catch(function(error) {
                console.log('download behavior raw data template error...', error);
                dispatch(actionCreator(DownLoadClientListActionTypes.downloadBehaviorRawDataTemplate.FAILURE, error.message));
            });
    };
};




// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downLoadClientList/actions/downloadClientListActions.js